import React, { useEffect, useState } from 'react';
import PerfilAdmin from './PerfilAdmin';
import '../styles/Perfil.css';
import { API_URL } from '../config';


type Producto = {
  nombre: string;
  imagen: string;
  color: string;
  precio: number;
  cantidad: number;
};

type Orden = {
  nro_orden: string;
  total: number;
  estado: string;
  metodo_pago: string;
  direccion: string;
  carrito: Producto[];
  created_at: string;
};

const Perfil: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'perfil' | 'ordenes' | 'admin'>('perfil');
  const [userData, setUserData] = useState<any>({});
  const [ordenes, setOrdenes] = useState<Orden[]>([]);
  const [ordenAbierta, setOrdenAbierta] = useState<number | null>(null);

  const toggleOrden = (index: number) => {
    setOrdenAbierta(ordenAbierta === index ? null : index);
  };

  const formatearEstado = (estado: string) => {
    switch (estado) {
      case 'en_revision':
        return { texto: 'En Revisión', clase: 'estado estado-amarillo' };
      case 'completado':
        return { texto: 'Completado', clase: 'estado estado-verde' };
      case 'cancelado':
        return { texto: 'Cancelado', clase: 'estado estado-rojo' };
      default:
        return { texto: estado, clase: 'estado' };
    }
  };
  
useEffect(() => {
  const fetchData = async () => {
    const token = localStorage.getItem('access_token');
    if (!token) return;

    // Aquí está el cambio: Usamos Template Literals con API_URL
    const res = await fetch(`${API_URL}/api/perfil/`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    
    // El resto del código permanece igual
    const data = await res.json();
    setUserData(data);
    setOrdenes(data.ordenes || []);
  };
  // Asegúrate de llamar a fetchData aquí o en la parte inferior del useEffect si el fetch es condicional.
  fetchData(); 
}, []); // Asumiendo que se ejecuta solo una vez al montar

  return (
    <div className="perfil-layout">
      <aside className="sidebar">
        <button
          className={activeTab === 'perfil' ? 'active' : ''}
          onClick={() => setActiveTab('perfil')}
        >
          Perfil
        </button>
        <button
          className={activeTab === 'ordenes' ? 'active' : ''}
          onClick={() => setActiveTab('ordenes')}
        >
          Órdenes
        </button>
        {userData.is_staff && (
          <button
            className={activeTab === 'admin' ? 'active' : ''}
            onClick={() => setActiveTab('admin')}
          >
            Admin
          </button>
        )}
      </aside>

      <main className="perfil-content">
        {activeTab === 'perfil' && (
          <div className="perfil-info">
            <h2>Información de Perfil</h2>
            <p><strong>Nombre:</strong> {userData.nombre || 'No registrado'}</p>
            <p><strong>Apellido:</strong> {userData.apellido || 'No registrado'}</p>
            <p><strong>Email:</strong> {userData.email || 'No registrado'}</p>
            <p><strong>Dirección:</strong> {userData.direccion || 'No registrada'}</p>
          </div>
        )}

        {activeTab === 'ordenes' && (
          <div className="ordenes-info">
            <h2>Órdenes del Usuario</h2>
            {ordenes.length === 0 ? (
              <p>No hay órdenes registradas.</p>
            ) : (
              <ul className="ordenes-lista">
                {ordenes.map((orden, index) => {
                  const estado = formatearEstado(orden.estado);
                  return (
                    <li key={orden.nro_orden} className="orden-item">
                      <div
                        className="orden-encabezado"
                        onClick={() => toggleOrden(index)}
                        style={{ cursor: 'pointer' }}
                      >
                        <p><strong>Nro Orden:</strong> {orden.nro_orden}</p>
                        <p><strong>Fecha:</strong> {new Date(orden.created_at).toLocaleString()}</p>
                        <p><strong>Estado:</strong> <span className={estado.clase}>{estado.texto}</span></p>
                      </div>

                      {ordenAbierta === index && (
                        <div className="orden-detalle">
                          <p><strong>Método de pago:</strong> {orden.metodo_pago}</p>
                          <p><strong>Dirección:</strong> {orden.direccion.trim() === ',' ? 'No Registrada' : orden.direccion}</p>
                          <p><strong>Total:</strong> ${orden.total.toLocaleString()}</p>
                          <div className="productos">
                            {orden.carrito.map((prod, idx) => (
                              <div key={idx} className="producto">
                                <img src={prod.imagen} alt={prod.nombre} />
                                <div>
                                  <p>{prod.nombre} ({prod.color})</p>
                                  <p>Precio: ${prod.precio}</p>
                                  <p>Cantidad: {prod.cantidad}</p>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                    </li>
                  );
                })}
              </ul>
            )}
          </div>
        )}

        {activeTab === 'admin' && userData.is_staff && (
          <div className="admin-panel">
            <PerfilAdmin />
          </div>
        )}
      </main>
    </div>
  );
};

export default Perfil;
